/* eslint-disable prettier/prettier */
/* eslint-disable */

export default {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
};
